import { Logo as HubLogo } from '@hub/logos';
import React from 'react';
import dynamic from 'next/dynamic';
import { jsx as _jsx } from "react/jsx-runtime";
export let CentreSlug = /*#__PURE__*/function (CentreSlug) {
  CentreSlug["airportwest"] = "airportwest";
  CentreSlug["albany"] = "albany";
  CentreSlug["belconnen"] = "belconnen";
  CentreSlug["bondijunction"] = "bondijunction";
  CentreSlug["booragoon"] = "booragoon";
  CentreSlug["burwood"] = "burwood";
  CentreSlug["carindale"] = "carindale";
  CentreSlug["carousel"] = "carousel";
  CentreSlug["chatswood"] = "chatswood";
  CentreSlug["chermside"] = "chermside";
  CentreSlug["coomera"] = "coomera";
  CentreSlug["doncaster"] = "doncaster";
  CentreSlug["eastgardens"] = "eastgardens";
  CentreSlug["fountaingate"] = "fountaingate";
  CentreSlug["geelong"] = "geelong";
  CentreSlug["helensvale"] = "helensvale";
  CentreSlug["hornsby"] = "hornsby";
  CentreSlug["hurstville"] = "hurstville";
  CentreSlug["innaloo"] = "innaloo";
  CentreSlug["knox"] = "knox";
  CentreSlug["kotara"] = "kotara";
  CentreSlug["liverpool"] = "liverpool";
  CentreSlug["manukau"] = "manukau";
  CentreSlug["marion"] = "marion";
  CentreSlug["miranda"] = "miranda";
  CentreSlug["mtdruitt"] = "mtdruitt";
  CentreSlug["mtgravatt"] = "mtgravatt";
  CentreSlug["national"] = "national";
  CentreSlug["newmarket"] = "newmarket";
  CentreSlug["northlakes"] = "northlakes";
  CentreSlug["parramatta"] = "parramatta";
  CentreSlug["penrith"] = "penrith";
  CentreSlug["plentyvalley"] = "plentyvalley";
  CentreSlug["riccarton"] = "riccarton";
  CentreSlug["southland"] = "southland";
  CentreSlug["stlukes"] = "stlukes";
  CentreSlug["sydney"] = "sydney";
  CentreSlug["teatreeplaza"] = "teatreeplaza";
  CentreSlug["tuggerah"] = "tuggerah";
  CentreSlug["warringahmall"] = "warringahmall";
  CentreSlug["westlakes"] = "westlakes";
  CentreSlug["whitfordcity"] = "whitfordcity";
  CentreSlug["woden"] = "woden";
  return CentreSlug;
}({});
const getCentreSlug = s => {
  const gaurd = s => {
    const values = Object.values(CentreSlug);
    return values.includes(s);
  };
  if (!gaurd(s)) {
    return undefined;
  }
  return s;
};
export const Logo = _ref => {
  let {
    variant = 'national',
    centreSlug
  } = _ref;
  const logoString = (() => {
    var _ref2;
    switch (variant) {
      case 'national':
      case 'account':
      case 'gift-cards':
        return variant;
      case 'centre':
        return (_ref2 = centreSlug && getCentreSlug(centreSlug)) !== null && _ref2 !== void 0 ? _ref2 : 'national';
    }
  })();
  const dynamicCentreLogo = dynamic(() => import("./assets/westfield-logo-red-".concat(logoString, ".inline.svg")), {
    loadableGenerated: {
      webpack: () => [require.resolveWeak("./assets/westfield-logo-red-".concat(logoString, ".inline.svg"))]
    }
  });
  return /*#__PURE__*/_jsx(HubLogo, {
    svg: logoString ? dynamicCentreLogo : undefined,
    "data-id": "logo_index_Logo_HubLogo"
  });
};